module.exports = __webpack_public_path__ + "static/me-5279c8d7a1c9cc8fd25f6168a47a1cf8.jpg";